import styled, { css } from 'styled-components'

export const StyledIframeWrapper = styled.div`
  margin-bottom: 20px;
  ${props => {
    return css`
      height: ${props.theme.height}px;
    `
  }};
`
export const StyledIframe = styled.iframe`
  ${props => props.theme.css};
  width: 100%;
  height: 100%;
`
